import { render } from "./index.vue?vue&type=template&id=303551ef&scoped=true"
const script = {}

import "./index.scss?vue&type=style&index=0&id=303551ef&lang=scss&scoped=true"

import exportComponent from "/builds/spark/services/frontend/admin-v2/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-303551ef"]])

export default __exports__